import VerbatimImageVideoGrid from './verbatimImageVideoGrid'
export default VerbatimImageVideoGrid
